<template>
	<v-layout row justify-center>
		<v-dialog
			v-model="showModal"
			lazy
			persistent
			max-width="700px"
			:transition="utils.getSettings('animation')"
			@keydown.esc="showModal = false"
		>
			<v-card class="compact">
				<v-form v-model="valid" ref="unitForm" lazy-validation>
					<v-tabs v-model="active" color="blue darken-3" dark>
						<v-tab v-for="tab in tabs" :key="tab" :href="'#' + tab" ripple>{{
							tab
						}}</v-tab>
						<v-tabs-slider color="yellow"></v-tabs-slider>
						<v-tabs-items :touchless="active === 'Kaart'">
							<v-tab-item :key="'Gegevens'" :value="'Gegevens'">
								<v-card>
									<v-card-title>
										<span class="headline"
											>{{
												parseInt(unitData.id) > 0
													? 'Wijzig unit'
													: 'Nieuwe unit'
											}}
											#{{ unitData.unitId }}</span
										>
									</v-card-title>
									<v-card-text>
										<v-layout wrap>
											<v-flex xs12 sm4 md4>
												<v-text-field
													label="Naam"
													v-model="unitData.name"
													required
													:rules="basicRules"
												></v-text-field>
											</v-flex>
											<v-flex xs12 sm4 md4>
												<v-text-field
													label="Kenteken"
													v-model="unitData.license"
													required
													:rules="basicRules"
												></v-text-field>
											</v-flex>
											<v-flex xs12 sm4 md4>
												<v-select
													label="Kleur"
													v-model="unitData.color"
													:items="colors"
													required
													:rules="basicRules"
												></v-select>
											</v-flex>
											<v-flex xs12 sm12 md12>
												<v-textarea
													label="Omschrijving"
													required
													:rules="basicRules"
													v-model="unitData.description"
												></v-textarea>
											</v-flex>
											<v-flex xs6>
												<v-text-field
													label="Parkeerlokatie Lat"
													v-model="unitData.parkingLat"
													required
													:rules="basicRules"
												></v-text-field>
											</v-flex>
											<v-flex xs6>
												<v-text-field
													label="Parkeerlokatie Lng"
													v-model="unitData.parkingLng"
													required
													:rules="basicRules"
												></v-text-field>
											</v-flex>
											<v-flex xs12>
												<v-text-field
													label="Parkeerlokatie omschrijving"
													v-model="unitData.standplaats"
													required
													:rules="basicRules"
												></v-text-field>
											</v-flex>
											<v-flex xs6>
												<v-select
													v-model="unitData.fuel"
													label="Brandstof"
													required
													:rules="basicRules"
													:items="['Benzine', 'Diesel', 'Elektrisch']"
												></v-select>
											</v-flex>
											<v-flex xs12 sm6>
												<v-select
													v-model="unitData.wialonUnitId"
													:items="availableDevices"
													label="Unit"
													item-text="description"
													item-value="id"
													required
													:rules="basicRules"
													@change="getDeviceData($event)"
												></v-select>
											</v-flex>
											<v-flex xs12 sm6 v-if="unitData.unitId > 0">
												<v-text-field
													label="UnitId"
													type="text"
													v-model="unitData.unitId"
													readonly
													:rules="basicRules"
												></v-text-field>
											</v-flex>
											<v-flex xs12 sm6 v-if="userType === 'with-site'">
												<v-checkbox
													label="Toon op website"
													v-model="unitData.active"
												></v-checkbox>
											</v-flex>
										</v-layout>
										<small>* Verplichte velden</small>
									</v-card-text>
								</v-card>
							</v-tab-item>
							<v-tab-item :key="'Instellingen'" :value="'Instellingen'">
								<v-card>
									<v-card-title>
										<span class="headline"
											>{{ unitData.id > 0 ? 'Wijzig unit' : 'Nieuwe unit' }} #{{
												unitData.unitId
											}}</span
										>
									</v-card-title>
									<v-card-text>
										<v-layout wrap>
											<v-flex xs12 sm6 md6 v-if="userType === 'with-site'">
												<v-checkbox
													label="Bel unit"
													v-model="callUnit"
												></v-checkbox>
											</v-flex>
											<v-flex xs12 sm6 md6>
												<v-checkbox
													label="Proefrit unit"
													v-model="testDriveUnit"
													:style="
														unitData.wialonUnitId === '0' ? 'display: none' : ''
													"
												></v-checkbox>
											</v-flex>
											<v-flex xs12 sm12 md12>
												<v-select
													v-model="unitData.priceCat"
													:items="prices"
													label="Prijscategorie"
													item-value="priceCat"
													item-text="groupDescription"
													required
													:rules="basicRules"
												></v-select>
											</v-flex>
											<v-flex
												xs12
												sm4
												md4
												:style="
													unitData.wialonUnitId === '0' ? 'display: none' : ''
												"
											>
												<v-text-field
													label="Sensor sleutel"
													required
													:rules="basicRules"
													v-model="unitData.sensor_id_key"
												></v-text-field>
											</v-flex>
											<v-flex
												xs12
												sm4
												md4
												:style="
													unitData.wialonUnitId === '0' ? 'display: none' : ''
												"
											>
												<v-text-field
													label="Sensor tankpas"
													required
													:rules="basicRules"
													v-model="unitData.sensor_id_fuelcard"
												></v-text-field>
											</v-flex>
											<v-flex
												xs12
												sm4
												md4
												:style="
													unitData.wialonUnitId === '0' ? 'display: none' : ''
												"
											>
												<v-text-field
													label="Sensor voltage"
													required
													:rules="basicRules"
													v-model="unitData.sensor_id_volt"
												></v-text-field>
											</v-flex>
											<v-flex
												xs12
												sm6
												md6
												:style="
													unitData.wialonUnitId === '0' ? 'display: none' : ''
												"
											>
												<v-text-field
													label="Sensor slot"
													required
													:rules="basicRules"
													v-model="unitData.sensor_id_closed"
												></v-text-field>
											</v-flex>
											<v-flex
												xs12
												sm6
												md6
												:style="
													unitData.wialonUnitId === '0' ? 'display: none' : ''
												"
											>
												<v-checkbox
													label="2 commando's voor auto openen/sluiten"
													v-model="lockDuoSensor"
												></v-checkbox>
											</v-flex>
											<v-flex xs12 sm4 md4>
												<v-text-field
													type="number"
													label="Pincode pas"
													required
													:rules="basicRules"
													v-model="unitData.fuelCardPin"
												></v-text-field>
											</v-flex>
											<v-flex xs12 sm4 md4>
												<v-text-field
													type="number"
													label="Kilometerprijs"
													required
													:rules="basicRules"
													v-model="unitData.kmPrice"
													min="0"
													step="0.01"
												></v-text-field>
											</v-flex>
												<v-flex xs12 sm4 md4>
												<v-text-field
													type="number"
													label="Kilometervrij"
													required
													:rules="basicRules"
													v-model="unitData.freeMileage"
													min="0"
													step="1"
												></v-text-field>
											</v-flex>
											<v-flex xs12 sm4 md4> </v-flex>
											<v-flex xs12 sm4 md4 mt-4>
												<input
													type="file"
													@change="setImage"
													accept="image/*"
												/>
												<img v-bind:src="image" v-if="image" />
											</v-flex>
										</v-layout>
										<small>* Verplichte velden</small>
									</v-card-text>
								</v-card>
							</v-tab-item>
							<v-tab-item :key="'Kaart'" :value="'Kaart'">
								<v-card>
									<v-card-text>
										<coordinate-picker
											v-if="this.deviceId !== '0'"
											:lat="unitData.parkingLat ? parseFloat(unitData.parkingLat) : 52.1326"
											:lng="unitData.parkingLng ? parseFloat(unitData.parkingLng) : 5.2913"
											@coordinates-selected="onCoordinatesSelected"
											@show-message="showMessage"
										></coordinate-picker>
										<p v-if="this.deviceId === '0'" class="mt-4">
											<v-alert type="info">
												Selecteer eerst een tracker in het tabblad "Gegevens" om de kaart te gebruiken.
											</v-alert>
										</p>
									</v-card-text>
								</v-card>
							</v-tab-item>

							<v-tab-item :key="'Opties'" :value="'Opties'">
								<v-card>
									<v-card-title>
										<span class="headline">Opties</span>
									</v-card-title>
									<v-card-text>
										<v-layout wrap>
											<unit-control
												v-if="sensors"
												:unitId="this.unitData.unitId"
												:sensors="sensors"
												:status="unitData.status"
											></unit-control>
										</v-layout>
									</v-card-text>
								</v-card>
							</v-tab-item>
							<v-layout row wrap>
								<v-flex xs8>
									<v-btn color="blue darken-1" flat @click.native="closeModal()"
										>Sluiten</v-btn
									>
								</v-flex>
								<v-flex xs4 text-xs-right>
									<v-btn color="primary darken-1" @click.native="updateUnit()"
										>Opslaan</v-btn
									>
								</v-flex>
							</v-layout>
						</v-tabs-items>
					</v-tabs>
				</v-form>
			</v-card>
		</v-dialog>
	</v-layout>
</template>
<script>
import * as utils from '@/utils/utils';
import UnitControl from '@/components/Units/UnitControl';
import CoordinatePicker from '@/components/subcomponents/CoordinatePicker';
import { _ } from 'vue-underscore';
//import Planner from '@/components/Planner'
export default {
	name: 'UnitModal',
	components: { UnitControl, CoordinatePicker },
	created: function() {},
	mounted: function() {
		this.getAvailableDevices();
		this.userType = localStorage.getItem('t');
	},
	data() {
		return {
			active: 'Gegevens',
			unitData: {
				sensors: {}
			},
			markers: [],
			valid: false,
			showMap: false,
			image: '',
			colors: [
				'Wit',
				'Zwart',
				'Grijs',
				'Zilver',
				'Rood',
				'Blauw',
				'Geel',
				'Groen',
				'Oranje',
				'Bruin',
				'Paars'
			],
			lat: '',
			phoneNo: '',
			lng: '',
			new: false,
			utils: utils,
			sensors: {},
			basicRules: [v => !!v || 'Verplicht veld'],
			prices: [],
			showModal: false,
			selectedUnit: {},
			availableDevices: [],
			userType: 'default'
		};
	},
	props: ['edit', 'id'],
	computed: {
		tabs() {
			if (this.unitData.id > 0) {
				return ['Gegevens', 'Instellingen', 'Kaart', 'Opties'];
			} else {
				return ['Gegevens', 'Instellingen'];
			}
		},
		deviceId() {
			return this.unitData.wialonUnitId
				? this.unitData.wialonUnitId
				: this.unitData.i;
		},
		testDriveUnit: {
			get() {
				return this.unitData.testDriveUnit === '1';
			},
			set(value) {
				this.unitData.testDriveUnit = value ? '1' : '0';
			}
		},
		callUnit: {
			get() {
				return this.unitData.callUnit === '1';
			},
			set(value) {
				this.unitData.callUnit = value ? '1' : '0';
			}
		},
		lockDuoSensor: {
			get() {
				return this.unitData.lock_duo_sensor === '1';
			},
			set(value) {
				this.unitData.lock_duo_sensor = value ? '1' : '0';
			}
		}
	},
	watch: {
		unitData(newValue) {
			this.setUnit();
		},
		active(val) {
			var self = this;
			if (val === 'Kaart' && !self.showMap) {
				setTimeout(function() {
					self.showMap = true;
				}, 100);
			}
		},
		showModal(val) {
			if (val) {
				this.getPrices();
			}
		}
	},
	methods: {
		closeModal() {
			this.showModal = false;
		},
		updateModel() {
			// Todo maybe better solution
			this.$emit('updateUnits');
		},
		getDeviceData(value) {
			const unit = _.findWhere(this.wialonUnits, { i: parseInt(value) });
			if (unit) {
				const selectedUnit = {
					name: this.unitData.name,
					wialonUnitId: String(unit.d.id),
					sensors: unit.d.sens,
					license: this.unitData.license,
					new: true
				};
				this.unitData = selectedUnit;
			} else {
				this.unitData.wialonUnitId = String(value);
				this.unitData.new = true;
				this.unitData.sensors = {};
			}
		},
		getAvailableDevices() {
			const self = this;
			utils
				.getData(basePath + 'api/rentunits/getWialonUnits')
				.then(function(json) {
					if (json.wialonUnits && json.wialonUnits.length) {
						const wialonUnits = json.wialonUnits;
						const availableDevices = [];
						for (let i = 0; i < wialonUnits.length; i++) {
							availableDevices.push({
								description: wialonUnits[i].d.nm,
								id: String(wialonUnits[i].d.id)
							});
						}

						availableDevices.unshift({
							description: 'Zonder tracker',
							id: '0'
						});
						self.availableDevices = availableDevices;
						self.wialonUnits = wialonUnits;
					}
				});
		},
		setUnit() {
			var self = this;
			self.phoneNo = '';
			if (!self.unitData.new) {
				this.new = false;
				if (self.unitData.pos) {
					this.markers[0] = {
						position: {
							lat: self.unitData.pos.y,
							lng: self.unitData.pos.x
						}
					};
					self.unitData.active = self.unitData.active === '1';
				} else {
					self.unitData.active = self.unitData.active === '1';
					self.getUnit();
				}

				self.getUnitSensorData();
			} else {
				this.new = true;
				self.unitData = self.unitData;
				var sensors = self.unitData.sensors;
				if (sensors) {
					var sensorKey = _.findWhere(sensors, { n: 'Sleutel_in_dash' });
					self.unitData.sensor_id_key = sensorKey ? sensorKey.id : '0';

					var sensorFuelCard = _.findWhere(sensors, { n: 'Tankpas_in_dash' });
					self.unitData.sensor_id_fuelcard = sensorFuelCard
						? sensorFuelCard.id
						: '0';

					var sensorVoltage = _.findWhere(sensors, { n: 'Accu voltage' });
					self.unitData.sensor_id_volt = sensorVoltage ? sensorVoltage.id : '0';

					var sensorLock = _.findWhere(sensors, { n: 'Auto_op_slot' });
					self.unitData.sensor_id_closed = sensorLock ? sensorLock.id : '0';
				} else {
					self.unitData.sensor_id_key = '0';
					self.unitData.sensor_id_fuelcard = '0';
					self.unitData.sensor_id_volt = '0';
					self.unitData.sensor_id_closed = '0';
				}
			}
		},
		getUnit() {
			var self = this;
			utils
				.getData(basePath + 'api/rentunits/getUnit/' + this.unitData.unitId)
				.then(function(json) {
					if (json && json.data && json.data.length) {
						self.unitData = json.data[0];
					}
				});
		},
		getUnitSensorData() {
			var self = this;
			utils
				.getData(basePath + 'api/rentunits/getUnitData/' + this.unitData.unitId)
				.then(function(json) {
					if (json.data && json.data.item) {
						self.phoneNo = json.data.item.ph;
						self.sensors = json.data.sensors;
						self.unitData.sens = json.data.sens;
					}
				});
		},
		updateUnit() {
			var self = this;
			if (this.$refs.unitForm.validate()) {
				this.unitData.new = this.new;
				this.unitData.image = this.image;
				this.unitData.wialonUnitId = this.deviceId;
				this.unitData.callUnit = this.callUnit;
				this.unitData.testDriveUnit = this.testDriveUnit;

				utils
					.setData(basePath + 'api/rentunits/updateUnit/', this.unitData)
					.then(function(json) {
						self.updateModel();
					});

				this.showModal = false;
			}
		},
		movePos(val) {
			this.lat = val.latLng.lat();
			this.lng = val.latLng.lng();
			if (this.markers[1]) {
				this.markers[1].position.lat = val.latLng.lat();
				this.markers[1].position.lng = val.latLng.lng();
			}
		},
		getPos(val) {
			this.lat = val.latLng.lat();
			this.lng = val.latLng.lng();
			var marker = {
				position: {
					lat: this.lat,
					lng: this.lng
				},
				animation: google.maps.Animation.DROP
			};

			if (this.markers[1]) {
				this.markers[1] = marker;
			} else {
				this.markers.push(marker);
			}
		},
		usePos() {
			this.unitData.parkingLat = this.lat;
			this.unitData.parkingLng = this.lng;
		},
		setImage(e) {
			var self = this;
			var files = e.target.files || e.dataTransfer.files;
			if (!files.length) return;

			var file = files[0];
			var image = new Image();
			var reader = new FileReader();
			var vm = this;

			reader.onload = e => {
				self.image = e.target.result;
			};

			reader.readAsDataURL(file);
		},
		getPrices() {
			const self = this;
			utils
				.getData(basePath + 'api/prices/getPriceGroups/')
				.then(function(json) {
					self.prices = json.data;
				});
		},
		onCoordinatesSelected(coordinates) {
			this.unitData.parkingLat = coordinates.lat;
			this.unitData.parkingLng = coordinates.lng;
			window.emitter.$emit('showToastMessage', {
				msg: `Coördinaten bijgewerkt: Lat ${coordinates.lat.toFixed(6)}, Lng ${coordinates.lng.toFixed(6)}`,
				type: 'success'
			});
		},
		showMessage(message) {
			window.emitter.$emit('showToastMessage', message);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Units/UnitModal.vue